import type {CSSProperties} from 'react';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeOnboardIndustryLook = 'industry-onboard-change';

export const isWedgeOnboardIndustryLook = (look: string): look is WedgeOnboardIndustryLook => look === 'industry-onboard-change';

/* Released onboarding industry confirm card (prep-screens-1 OnboardIndustry): the Change button that clears the locked pick. A transparent pill
   with a half pixel bold separator, a 10px radius, 8px by 12px of padding and 12.5px type at weight 600 on the secondary ink, which does not
   shrink on the card flex line and fades its border, ink and fill over 180ms. It reads the exact legacy roles, in the order of the source.
   The caller owns the label, the handler, the type and the shipped wedge-pill class (hover and focus paint from it). The look name starts with
   industry-, which the shared rule leaves without a transparent target: a browser hit grid showed the target answering clicks in a band
   where the legacy button has none. */

const PADDING = '8px 12px', RADIUS = 10, FONT = 12.5, WEIGHT = 600, FADE = 180;

export function wedgeOnboardIndustryStyle(_look: WedgeOnboardIndustryLook): CSSProperties {
  const r = wedgeExactRole;
  return {
    background: 'transparent', border: `0.5px solid ${r('separatorBold')}`, borderRadius: RADIUS, padding: PADDING,
    fontSize: FONT, fontWeight: WEIGHT, color: r('labelSec'), fontFamily: r('font'), cursor: 'pointer', flexShrink: 0,
    transition: `all ${FADE}ms ${r('ease')}`,
  };
}
